module.exports = __webpack_public_path__ + "8b1133d7.png";